import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import {
  AdminsPage,
  PrestatairesPage,
  Dashboard,
  LoginPage,
  OrdersPage,
  PrivateRoute,
  ProductsPage,
  SingleOrderPage,
  SingleProductPage,
  AddNewProductPage,
  UpdateProductPage,
  CategoriesPage,
  HeroImagesPage,
  PlatformReviewsPage,
  ExternalOrdersPage,
} from './pages';

function App() {
  return (
    <Router>
      <Switch>
        <PrivateRoute exact path='/'>
          <Dashboard />
        </PrivateRoute>
        <PrivateRoute exact path='/orders'>
          <OrdersPage />
        </PrivateRoute>
        <PrivateRoute exact path='/external-orders'>
          <ExternalOrdersPage />
        </PrivateRoute>
        <PrivateRoute exact path='/orders/:id'>
          <SingleOrderPage />
        </PrivateRoute>
        <PrivateRoute exact path='/products'>
          <ProductsPage />
        </PrivateRoute>
        <PrivateRoute exact path='/products/new'>
          <AddNewProductPage />
        </PrivateRoute>
        <PrivateRoute exact path='/products/:id'>
          <SingleProductPage />
        </PrivateRoute>
        <PrivateRoute exact path='/products/edit/:id'>
          <UpdateProductPage />
        </PrivateRoute>
        <PrivateRoute exact path='/categories'>
          <CategoriesPage />
        </PrivateRoute>
        <PrivateRoute exact path='/hero-images'>
          <HeroImagesPage />
        </PrivateRoute>
        <PrivateRoute exact path='/platform-reviews'>
          <PlatformReviewsPage />
        </PrivateRoute>
        <PrivateRoute exact path='/admins'>
          <AdminsPage />
        </PrivateRoute>
        <PrivateRoute exact path='/prestataires'>
          <PrestatairesPage />
        </PrivateRoute>
        <PrivateRoute exact path='/login'>
          <LoginPage />
        </PrivateRoute>
      </Switch>
    </Router>
  );
}

export default App;
